import React from 'react';
import classNames from 'classnames';
import Avatar from '@alltrails/shared/components/Avatar';
import { Context } from 'types/Context';
import User from 'types/User';
import * as styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { LanguageSupportUtil } from '../../../utils/language_support_util';

type UserImageLinkProps = {
  context: Context;
  user: User & { firstName?: string; lastName?: string };
  className?: string;
  size48?: boolean;
};

const UserImageLink = ({ context, user, className, size48 }: UserImageLinkProps) => {
  if (!user) {
    return null;
  }

  const linkClass = size48 ? styles.link48 : styles.link;

  return (
    <a
      className={classNames('clickable', linkClass, StringConstantsMixin.constants.XLATE.NONE, className)}
      href={LanguageSupportUtil.wrapUrlSafe(ServerCommunicationUtil.usersPath(user), context ? context.languageRegionCode : 'en-US')}
      target="_blank"
      title={`${user.first_name || user.firstName} ${user.last_name || user.lastName}`}
      onClick={e => e.stopPropagation()}
    >
      <Avatar
        name={StringConstantsMixin.strings.USER_AVATAR_ALT}
        src={
          user.profile_photo_url
            ? user.profile_photo_url
            : `/api/alltrails/profile_photos/${user.id}/image?size=icon&key=${ServerCommunicationUtil.apiKey}`
        }
        lazy
        fill
      />
    </a>
  );
};

export default UserImageLink;
